import { Grid2, Typography } from "@mui/material";
import React from "react";
import DemoCheckCircle from "../../../assets/icons/DemoCheckCircle";
import DemoUnCircle from "../../../assets/icons/DemoUnCircle";
import CommonButton from "../../../component/Button";
import { CustomDiv } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { SelectCreateCard } from "../../home/style";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function StartDemo({
  handleBack,
  filteredQuickLink,
  handleCheckChange,
  handleDemoCardChange,
  handleSkip,
}) {
  return (
    <CustomDiv>
      <CommonGrid2 display={"flex"} container justifyContent={"space-between"}>
        <Typography variant="h1" fontSize={"32px"}>
          Trial
        </Typography>
        <CommonButton
          value={"Back"}
          padding={"10px 3rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          onClick={() => handleBack(0)}
        />
      </CommonGrid2>
      <Typography
        variant="h3"
        fontWeight={300}
        color="#5B738B"
        marginTop={"1.5rem"}
      >
        Just click a card to start your trial.
      </Typography>

      <CommonGrid2 container spacing={2} marginTop={"2rem"}>
        {filteredQuickLink.map((item, index) => (
          <Grid2
            item
            size={{
              xs: 12,
              sm: 6,
              md: 4,
              lg: 3.1,
              xl: 2.4,
            }}
          >
            <SelectCreateCard
              key={index}
              minHeight="100%"
              gap="10px"
              padding="12px"
              justifyContent="space-between"
              condition={true}
              onClick={() => handleDemoCardChange(index)}
            >
              <CustomDiv>{item.icon}</CustomDiv>
              <CommonGrid2 display={"flex"} alignItems={"end"} gap={"10px"}>
                <CustomDiv>
                  <Typography
                    color="#354A5F"
                    variant="h6"
                    fontSize={"15px"}
                    fontWeight={600}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    color="#5B738B"
                    fontSize={"14px"}
                    fontWeight={500}
                  >
                    {item.description}
                  </Typography>
                </CustomDiv>
                <CustomDiv>
                  {item.selected ? <DemoCheckCircle /> : <DemoUnCircle />}
                </CustomDiv>
              </CommonGrid2>
            </SelectCreateCard>
          </Grid2>
        ))}
      </CommonGrid2>
      <CommonGrid2 display={"flex"} justifyContent="end" marginTop="3rem">
        <CommonButton
          value={
            filteredQuickLink.every((item) => item.selected)
              ? "Next"
              : "Skip for now"
          }
          padding={"10px 5rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          background={"transparent"}
          boxShadow={"none"}
          color="#6941C6"
          endIcon={<ArrowForwardIcon />}
          customStyle={{
            "& svg": {
              fontSize: "x-large !important",
            },
            "&:hover": {
              boxShadow: "none",
            },
          }}
          onClick={handleSkip}
        />
      </CommonGrid2>
    </CustomDiv>
  );
}
